import {Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React from "react";
import {get, patch} from '../../lib/axios'
import {connect} from "react-redux";

// [#138] 노드 드래그 종료 시, 놓인 위치가 자신이 속하지 않은 그룹의 bounding box 안이라면
// 이 그룹에 편입할지("포함하기") 아니면 위치만 반영할지("위치만 옮기기")를 확인한다.
function GroupJoinConfirm({is_open, node_id, group_id, group_label, selected_map_id, close, set}) {
    const handleJoin = () => {
        patch(`/api/v1/seomalmap/${selected_map_id}/node/${String(node_id).replace('N', '')}/group/`, {group: group_id}, () => {
            get(`/api/v1/seomalmap/${selected_map_id}/`, {}, (json) => {
                set(json.data.elements, Number(selected_map_id), {read_public: json.data.read_public, write_public: json.data.write_public});
            });
            close();
        });
    };

    return (
        <Dialog open={is_open} onClose={close} style={{zIndex: 10000}}>
            <DialogContent style={{minWidth: '310px'}}>
                <DialogContentText>
                    "{group_label}" 그룹 안으로 옮겼어요. 이 그룹에 포함할까요?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={close} color="primary">
                    위치만 옮기기
                </Button>
                <Button onClick={handleJoin} color="primary">
                    포함하기
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default connect(
    (state) => {
        return {
            is_open: state.getIn(['ui', 'group_join_confirm', 'open']),
            node_id: state.getIn(['ui', 'group_join_confirm', 'node_id']),
            group_id: state.getIn(['ui', 'group_join_confirm', 'group_id']),
            group_label: state.getIn(['ui', 'group_join_confirm', 'group_label']),
            selected_map_id: state.getIn(['map', 'selected_map_id'])
        }
    },
    (dispatch) => {
        return {
            close: () => dispatch({type: 'CLOSE_GROUP_JOIN_CONFIRM'}),
            set: (value, map_id, permission) => {
                dispatch({type: 'SET_MAP', value: value, selected_map_id: map_id, permission: permission})
            }
        }
    }
)(GroupJoinConfirm)
